module.exports = __webpack_public_path__ + "assets/img/BodyLux.fa35e4ac.jpg";